import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../components/Form/Field'
import InventoryOverviewSpoiler from '../../../components/InventoryOverviewSpoiler'

import { formatOptionsList } from '../../../../../../../features/formatters'

import { lineItemsSelector } from '../../../../../../../modules/selectors/lineItems'
import { gamRightUploadAdDataSelector } from '../../../../../../../modules/selectors/rights'

import { LINE_ITEM } from '../../../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../../../hooks/formHooks/listItemFormHooks/fields'

const stepFields = [LINE_ITEM]

const LineItemStep = ({ formik, handleStepChange, showContinueButton = false }) => {
  const { t } = useTranslation()

  const lineItems = useSelector(lineItemsSelector)
  const { campaign } = useSelector(gamRightUploadAdDataSelector)
  const campaignId = campaign?.id

  const { values, setFieldValue } = formik

  const formattedLineItems = useMemo(() => {
    return formatOptionsList({
      list: lineItems.filter(lineItem => lineItem.order_id === campaignId),
      valueName: 'id',
      labelName: 'name'
    })
  }, [lineItems, campaignId])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step
      stepTitle={t('Which line item should the ad be uploaded to?')}
      handleContinue={showContinueButton ? handleContinue : null}
    >
      <InventoryOverviewSpoiler />
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_existing_line_item"
        name={LIST_ITEM_OPTION}
        label={t('An existing line item')}
        value={OPTION_EXISTING_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      >
        <Field formik={formik} name={LINE_ITEM} placeholder={t('Select a line item')} options={formattedLineItems} />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_new_line_item"
        name={LIST_ITEM_OPTION}
        label={t('A new line item')}
        value={OPTION_NEW_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      />
    </Step>
  )
}

LineItemStep.propTypes = {
  showContinueButton: PropTypes.bool
}

export default LineItemStep
